module.exports = __webpack_public_path__ + "img/newsImg10-2.c262db96.png";